/**
 * @generated SignedSource<<0c6fca161998fc832788a9e998414546>>
 * @relayHash b23890515d870d7794052b00109357a9
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 8441efc3d6affe7e57eb88458bc5bd24a244282175c873a79b1b56217aeec22b

import type { ConcreteRequest, Mutation } from 'relay-runtime';
export type JiraPublishIssueSearchConfigInput = {
  viewId: string;
};
export type SaveResetViewSettingsButtonUIPublishSettingsMutation$variables = {
  input: JiraPublishIssueSearchConfigInput;
};
export type SaveResetViewSettingsButtonUIPublishSettingsMutation$data = {
  readonly jira_publishIssueSearchConfig: {
    readonly errors: ReadonlyArray<{
      readonly extensions: {
        readonly errorType: string | null | undefined;
        readonly statusCode: number | null | undefined;
      } | null | undefined;
      readonly message: string | null | undefined;
    }> | null | undefined;
    readonly success: boolean;
  } | null | undefined;
};
export type SaveResetViewSettingsButtonUIPublishSettingsMutation = {
  response: SaveResetViewSettingsButtonUIPublishSettingsMutation$data;
  variables: SaveResetViewSettingsButtonUIPublishSettingsMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "kind": "ScalarField",
  "name": "success"
},
v3 = {
  "kind": "ScalarField",
  "name": "message"
},
v4 = {
  "kind": "ScalarField",
  "name": "errorType"
},
v5 = {
  "kind": "ScalarField",
  "name": "statusCode"
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "SaveResetViewSettingsButtonUIPublishSettingsMutation",
    "selections": [
      {
        "args": (v1/*: any*/),
        "concreteType": "JiraPublishIssueSearchConfigPayload",
        "kind": "LinkedField",
        "name": "jira_publishIssueSearchConfig",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "concreteType": "MutationError",
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v3/*: any*/),
              {
                "kind": "LinkedField",
                "name": "extensions",
                "plural": false,
                "selections": [
                  (v4/*: any*/),
                  (v5/*: any*/)
                ]
              }
            ]
          }
        ]
      }
    ],
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "SaveResetViewSettingsButtonUIPublishSettingsMutation",
    "selections": [
      {
        "args": (v1/*: any*/),
        "concreteType": "JiraPublishIssueSearchConfigPayload",
        "kind": "LinkedField",
        "name": "jira_publishIssueSearchConfig",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "concreteType": "MutationError",
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v3/*: any*/),
              {
                "kind": "LinkedField",
                "name": "extensions",
                "plural": false,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "__typename"
                  },
                  (v4/*: any*/),
                  (v5/*: any*/),
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "name": "id"
                      }
                    ],
                    "type": "BulkMutationErrorExtension"
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "8441efc3d6affe7e57eb88458bc5bd24a244282175c873a79b1b56217aeec22b",
    "metadata": {},
    "name": "SaveResetViewSettingsButtonUIPublishSettingsMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "bfef07a629bc5ee9a43033513612e22f";

export default node;
